import { useQuery } from '@tanstack/react-query'

import { ordersListReceivedReturns } from '@repo/sdk'

import type { ReturnStatus } from './returnStatusConfig'

const STATUSES: ReturnStatus[] = ['REQUESTED', 'APPROVED', 'REJECTED', 'REFUNDED']

async function fetchReturnCounts(): Promise<Record<ReturnStatus, number>> {
  const results = await Promise.all(
    STATUSES.map((status) =>
      ordersListReceivedReturns({ query: { page: 1, pageSize: 1, status } }),
    ),
  )

  return {
    REQUESTED: results[0]?.data?.meta.totalItems ?? 0,
    APPROVED: results[1]?.data?.meta.totalItems ?? 0,
    REJECTED: results[2]?.data?.meta.totalItems ?? 0,
    REFUNDED: results[3]?.data?.meta.totalItems ?? 0,
  }
}

const DEFAULT_COUNTS: Record<ReturnStatus, number> = {
  REQUESTED: 0,
  APPROVED: 0,
  REJECTED: 0,
  REFUNDED: 0,
}

export function useReturnTabCounts() {
  const { data, isLoading } = useQuery({
    queryKey: ['returnTabCounts'],
    queryFn: fetchReturnCounts,
  })

  return {
    counts: data ?? DEFAULT_COUNTS,
    isLoading,
  }
}
